// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"63747188","693":"1cae2164"}[chunkId] + ".chunk.js";
};